import { Card } from "primereact/card";
import { useParams } from "react-router-dom";

import CustomeButton from "~/components/Button";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES from "~/api-routes";
import AdminOnly from "~/components/AdminOnly";
import FileUploadModal from "~/components/Processes/conversations/FileUploadModal";

import CoreEntityAttachmentTable from "./CoreEntityAttachmentTable";
import useCoreEntityAttachments from "./useCoreEntityAttachments";
import Notification from "../notification/Notification";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";

import "./core-entity-attachments.scss";

const CoreEntityAttachments = () => {
  const { id } = useParams();

  const {
    attachments,
    loading,
    page,
    rows,
    totalRecords,
    onPageChange,
    isDataAvailable,
    entitydata,
    showUploadModal,
    fileSupported,
    setShowUploadModal,
    uploadFileHandler,
    requestdata,
    isFileUploaded,
    successMessage,
    setSuccessMessage,
    isAuditSidebarVisible,
    setAuditSidebarVisible,
    first,
    handleDeleteDocument,
    attachmentConfirmModal,
    setAttachmentConfirmModal,
    handleConfirmDelete,
    handleRestoreAttachment,
    temporaryMessage,
    isAttachmentLoader,
    setTemporaryMessage,
    restoreMessage,
    setRstoreMessage,
  } = useCoreEntityAttachments();
  const auditLabels = () => {
    return {
      create: "File Uploaded",
      update: "Address Updated",
      delete: "File(s) Deleted",
    };
  };
  return (
    <Card className="gen-card h-full">
      <div className="flex justify-content-between align-items-center mb-5">
        <p className="heading-primary">Attachments</p>
        <div className="flex gap-2">
          <AdminOnly>
            <CustomeButton
              label="View History"
              icon="pi pi-history"
              iconPos="right"
              onClick={() => setAuditSidebarVisible(true)}
            />

            <CustomeButton
              label="Upload File"
              variant="contained"
              icon="pi pi-plus"
              iconPos="right"
              onClick={() => {
                setShowUploadModal(true);
              }}
            />
          </AdminOnly>
        </div>
      </div>
      <Notification
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
      />
      <TemporaryNotification
        onUndo={handleRestoreAttachment}
        successMsg={temporaryMessage}
        setMessages={setTemporaryMessage}
      />
      <AttachmentSuccess
        successMsg={restoreMessage}
        setMessages={setRstoreMessage}
      />
      <CoreEntityAttachmentTable
        attachments={attachments}
        loading={loading}
        page={page}
        rows={rows}
        first={first}
        totalRecords={totalRecords}
        onPageChange={onPageChange}
        isDataAvailable={isDataAvailable}
        setOpenDialog={setShowUploadModal}
        handleAttachmentDelete={handleDeleteDocument}
      />
      <FileUploadModal
        entitydata={entitydata}
        showModal={showUploadModal}
        fileSupported={fileSupported}
        hideUploadModal={() => setShowUploadModal(false)}
        setUploadedFile={uploadFileHandler}
        getService={() => {
          return { name: "Core Entity Information" };
        }}
        requestdata={requestdata}
        loading={!isFileUploaded}
        close={false}
        relatedType={"ENTITIES_PLUS"}
      />

      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Attachments"
          endpoint={API_ROUTES.FETCH_ATTACHMENT_AUDIT}
          id={id}
          objectType="ENTITIES_PLUS"
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          labels={auditLabels}
        />
      )}
      {attachmentConfirmModal && (
        <DocumentConfirmationDialog
          visible={attachmentConfirmModal}
          closeModal={() => setAttachmentConfirmModal(false)}
          handleSave={handleConfirmDelete}
          isLoader={isAttachmentLoader}
        />
      )}
    </Card>
  );
};

export default CoreEntityAttachments;
